// extracted by mini-css-extract-plugin
export default {"mCard":"iB-z","image":"jB-z","imageNoBackground":"kB-z","imageHasCategory":"lB-z","fullWidth":"mB-z"};